module.exports = __webpack_public_path__ + "static/img/zhongzhongka17.8453fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka17.png
// module id = wcP4
// module chunks = 16